import { render, staticRenderFns } from "./ChatWithEmployee.vue?vue&type=template&id=71b8ad86&"
import script from "./ChatWithEmployee.vue?vue&type=script&lang=js&"
export * from "./ChatWithEmployee.vue?vue&type=script&lang=js&"
import style0 from "./ChatWithEmployee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports